import UberDirectService from '@/services/uberDirect/uberDirectService';

const uberDeliveryValidate: (
  orderUuid: string,
  address: string
) => any = async (orderUuid, address) => {
  try {
    const res = await UberDirectService.uberDeliveryValidate(
      orderUuid,
      address
    );
    return await Promise.resolve(res.data);
  } catch (err) {
    console.log('axios error', err);
    throw err;
  }
};

export { uberDeliveryValidate };
